import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import TextValue from "./controls/TextValue";
import MeasureValue from "./controls/MeasureValue";
import ListValue from "./controls/ListValue";

export function ResiduoPatogenicoList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((item, index) => (
        <ListGroupObjectItem
          key={item.orden}
          index={index}
          value={item}
          indexLabel={t("residuoPatogenico.orden")}
          editable
          onEdit={(event) => {
            event.preventDefault();
            select(index);
            document.getElementById("residuosPatogenicos").scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}
          deletable
          onDelete={(event) => {
            event.preventDefault();
            remove(index);
          }}
          disabled={disabled}
        >
          {({ value }) => (
            <Grid>
              <Row>
                <Col>
                  <TextValue
                    label={t("residuoPatogenico.descripcion")}
                    value={value?.descripcion}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <MeasureValue
                    label={t("residuoPatogenico.cantidad")}
                    value={value?.cantidad}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <ListValue
                    label={t("residuoPatogenico.operacionesUnitarias")}
                    value={value?.operacionesUnitarias}
                    labelAttr="nombre"
                  />
                </Col>
              </Row>
            </Grid>
          )}
        </ListGroupObjectItem>
      ))}
    </ListGroup>
  );
}
